(() => {
  const instances = new Map();

  class AWArticleActions {
    constructor(root) {
      this.root = root;
      this.button = root.querySelector("[data-aw-article-share-button]");
      this.message = root.querySelector("[data-aw-article-share-message]");

      this.onClick = this.onClick.bind(this);

      if (this.button) {
        this.button.addEventListener("click", this.onClick);
      }
    }

    async onClick() {
      if (!this.button) {
        return;
      }

      const url = this.button.dataset.shareUrl;
      const title = this.button.dataset.shareTitle || document.title;

      if (!url) {
        return;
      }

      try {
        if (navigator.share) {
          await navigator.share({ title, url });
          this.setMessage("");
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
          this.setMessage("");
          return;
        }

        this.setMessage("");
        window.prompt("", url);
      } catch (error) {
        this.setMessage("");
      }
    }

    setMessage(text) {
      if (!this.message) {
        return;
      }

      this.message.textContent = text;
    }

    destroy() {
      if (this.button) {
        this.button.removeEventListener("click", this.onClick);
      }
    }
  }

  const init = (container = document) => {
    container.querySelectorAll("[data-aw-article-actions]").forEach((root) => {
      if (instances.has(root)) {
        return;
      }

      instances.set(root, new AWArticleActions(root));
    });
  };

  const destroy = (container) => {
    container.querySelectorAll("[data-aw-article-actions]").forEach((root) => {
      const instance = instances.get(root);

      if (!instance) {
        return;
      }

      instance.destroy();
      instances.delete(root);
    });
  };

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:section:unload", (event) => destroy(event.target));
})();
